import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import fetchCustomer from '../../actions/customers/fetchCustomer'
import setCustomer from '../../actions/customers/setCustomer'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchCustomer = function* onFetchCustomer() {
  yield takeLatest(actionTypes.CUSTOMERS.FETCH, function* onFetchCustomerSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const { payload: { id } } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.customers}/${id}`,
        params: {
          include: 'administrator',
        },
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchCustomer() {
          yield put(fetchCustomer(id))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setCustomer(response.data.data, response.data.included))

    acceptAction(action, response.data.data)
  })
}

export default onFetchCustomer
